<template>
    <div>
        <box-cota :data="data" />
    </div>
</template>

<script>
// Components.
import BoxCota from './components/Index'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { BoxCota },
    mixins: [repository, formats],
    props: {
        data: { type: Object, required: true },
    }
}
</script>